import styled from "styled-components";
import ImageSlider from "../components/ImageSlider";
import ip1 from "../images/ip1.JPEG";
import ip2 from "../images/ip2.JPEG";
import ip3 from "../images/ip3.JPEG";

const Section = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;
`;

const TitleWrapper = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 50px;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const Title = styled.div`
  font-size: 40px;
  font-weight: 500;
  color: #111111;
  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const GrayText = styled.span`
  color: #797979;
  z-index: 1;
`;

const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #797979;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const ExWrapper = styled.div`
  width: 100%;
  padding: 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  gap: 100px;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  @media (max-width: 768px) {
  }
`;

const DescriptionBox = styled.div`
  flex: 1;
  max-width: 600px;
  @media (max-width: 1200px) {
    order: 2;
    margin-top: 20px;
  }
`;

const DesTitle = styled.div`
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #111111;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const DesText = styled.div`
  font-size: 20px;
  line-height: 1.7;
  color: #111111;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const MoveinSection = () => {
  return (
    <Section>
      <TitleWrapper>
        <Title>
          입주 · 이사 <GrayText>청소</GrayText>
        </Title>
        <SubTitle>cleaning of the house</SubTitle>
      </TitleWrapper>
      <ExWrapper>
        <DescriptionBox>
          <DesTitle>입주 전, 새집의 첫인상을 책임집니다</DesTitle>
          <DesText>
            신축 건물 첫 입주 시, 시공 후 남은 먼지와 오염은
            <br />
            호흡기 문제를 비롯한 각종 질환의 원인이 될 수 있습니다.
            <br />
            <br />
            백앤클린의 전문 노하우로 미세 분진까지 깨끗하게 제거해
            <br />
            새집의 진짜 첫인상을 완성하세요.
          </DesText>
        </DescriptionBox>
        <ImageSlider images={[ip1, ip2, ip3]} />
      </ExWrapper>
    </Section>
  );
};

export default MoveinSection;
